import type { GlobalSearchKind, GlobalSearchResponse } from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * Single-shot global search; ~five rows per kind. Server caps the limit at
 * 10; we pass 5 by default. The CommandPalette debounces calls so this is
 * only invoked once the user has paused typing.
 */
export const globalSearch = async (
  q: string,
  opts?: { kinds?: readonly GlobalSearchKind[]; limit?: number; signal?: AbortSignal },
): Promise<GlobalSearchResponse> => {
  const { data } = await apiClient.get<GlobalSearchResponse>('/search', {
    params: {
      q,
      kinds: opts?.kinds ? opts.kinds.join(',') : undefined,
      limit: opts?.limit,
    },
    signal: opts?.signal,
  });
  return data;
};
